export { CurrencyRupee as default } from './CurrencyRupee';
